// extracted by mini-css-extract-plugin
export default {"tableRow":"AddExpenseItem_tableRow__W8mAQ"};